import API_BASE from '../../utils/api';
import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
// Add this import at the top
import ProfileDropdown from "../../components/ProfileDropdown";

// Replace the nav section with this:

const TeacherSubjects = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const response = await axios.get(
        `${API_BASE}/teachers/${user._id}/subjects`,
      );
      setSubjects(response.data);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (loading) {
    return (
      <div className="flex">
        <Sidebar />
        <div className="flex-1 bg-gray-100 flex items-center justify-center h-screen">
          <div className="text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 bg-gray-100 min-h-screen">
        <nav className="bg-white shadow-sm sticky top-0 z-10">
          <div className="px-6 py-4 flex justify-between items-center">
            <h1 className="text-2xl font-semibold text-gray-800">
              My Subjects
            </h1>
            <ProfileDropdown />
          </div>
        </nav>

        <div className="p-6">
          {subjects.length === 0 ? (
            <div className="bg-white rounded-lg shadow p-12 text-center">
              <span className="text-6xl mb-4 block">📚</span>
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                No Subjects Assigned
              </h2>
              <p className="text-gray-500">
                You haven't been assigned any subjects yet.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {subjects.map((subject, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow overflow-hidden hover:shadow-lg transition"
                >
                  <div className="h-2 bg-indigo-600"></div>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <span className="text-4xl">📖</span>
                      <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm">
                        {subject.className}-{subject.section}
                      </span>
                    </div>

                    <h3 className="text-xl font-semibold mb-2">
                      {subject.subjectName}
                    </h3>

                    <div className="space-y-2 mt-4">
                      <p className="text-sm text-gray-600">
                        <span className="font-medium">Class:</span>{" "}
                        {subject.className} - Section {subject.section}
                      </p>
                      {subject.teacherId && (
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Teacher:</span>{" "}
                          {subject.teacherId.name}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Teaching Schedule Summary */}
          {subjects.length > 0 && (
            <div className="mt-8 bg-white rounded-lg shadow overflow-hidden">
              <div className="px-6 py-4 bg-green-600 text-white">
                <h2 className="text-lg font-semibold">Weekly Schedule</h2>
              </div>
              <div className="p-6">
                <div className="grid grid-cols-5 gap-2">
                  {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map(
                    (day, index) => (
                      <div key={day} className="text-center">
                        <p className="font-medium text-sm mb-2">{day}</p>
                        <div className="space-y-2">
                          {subjects.slice(0, 2).map((subject, idx) => (
                            <div
                              key={idx}
                              className="bg-indigo-50 p-2 rounded text-xs"
                            >
                              <p className="font-semibold">
                                {subject.subjectName}
                              </p>
                              <p className="text-gray-500">{index + 9}:00 AM</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeacherSubjects;
